module.exports = __webpack_public_path__ + "static/img/zhuli.087b6d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/market/zhuli.png
// module id = 9LER
// module chunks = 2